<!--
@create date 2023-10-31
@desc TP88.phomemo.com
-->
<template>
  <div class="m833GuideDiv">
    <div class="scroll-items-div">
      <ul>
        <li
          :class="
            clickName === 'driversRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('driversRef')"
        >
          DRIVERS
        </li>

        <li
          :class="
            clickName === 'appDownloadRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('appDownloadRef')"
        >
          APP
        </li>

        <li
          :class="
            clickName === 'faqRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('faqRef')"
        >
          FAQ
        </li>
        <li
          :class="
            clickName === 'contactRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('contactRef')"
        >
          Contact Us
        </li>
        <!-- <li
          :class="
            clickName === 'alsoLikeRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('alsoLikeRef')"
        >
          You May Also Like
        </li> -->
      </ul>
    </div>
    <div class="topContainerDiv">
      <h1>TP88 Tattoo Stencil Printer Support</h1>
      <div class="productDiv">
        <div class="leftDiv">
          <img
            src="https://oss.qu-in.top/printerFiles/phomemo/TPX/TP88.png"
            style="margin: 10px auto; width: 250px"
            title="Click to view more"
            @click="
              () => {
                window.open('https://www.amazon.com/dp/B0CYWXT96S');
              }
            "
          />
        </div>
        <div class="rightDiv">
          <div class="descripeDiv">
            <p>
              NEW Upgraded TP88 Wireless Tattoo Stencil Printer for Tattoo
              Artists & Beginners, Compatible with Tablet,Smartphone & PC.
            </p>
            <p>
              Please take a moment to explore the intuitive interface, designed
              to guide you in configuring the printer to perfectly suit your
              needs.
            </p>
          </div>
          <p class="rightTitle" style="font-size: 18px">
            If you want to view the Manuals For TP88, Please click below Link:
          </p>
          <div class="linkDiv">
            <div
              v-for="(item, index) in tp88Info.guidesList"
              :key="index"
              class="downloadBtnNewest"
              title="Click to view"
              @click="
                () => {
                  window.open(item.url);
                  if (item.buryKey) refreshRecord({ key: item.buryKey });
                }
              "
            >
              <img :src="item.iconUrl" />
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/videosIcon.png"
          style="margin: 0"
        />
        <div class="textContainer" ref="driversRef">DRIVERS</div>
      </div>
      <br />

      <div class="videosDivE">
        <div class="leftDiv">
          <img
            class="videoLogoImg"
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 0 auto"
          />
          <a class="a-link">For Windows</a>
        </div>
        <div class="centerDiv">
          <p>Windows 7 (32 and 64 bit)</p>
          <p>Windows 8 (32 and 64 bit)</p>
          <p>Windows 10 (32 and 64 bit)</p>
          <p>Windows 11 (64 bit)</p>
          <div class="bottomDownloadDiv">
            <div
              class="downloadBtnNew"
              title="Click to download"
              @click="
                () => {
                  window.open(
                    'https://oss.qu-in.life/Phomemo/QY_Printer_Driver_Win.zip'
                  );
                }
              "
            >
              DOWNLOAD
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
              />
            </div>
            <span class="showSizeDiv" title="File Size">(3.18 MB)</span>
          </div>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster=""
            style="width: 100%"
            id="TP81_tattoo_windowsVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/TP81/Windows%E7%89%88%E6%9C%AC.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />

      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Mac</a>
        </div>
        <div class="centerDiv" style="padding-top: 3%">
          <p>MacOS 10.14 and above</p>
          <div class="bottomDownloadDiv">
            <div
              class="downloadBtnNew"
              title="Click to download"
              @click="
                () => {
                  window.open(
                    'https://oss.qu-in.life/Phomemo/QY_Printer_Driver_Mac.zip'
                  );
                }
              "
            >
              DOWNLOAD
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
              />
            </div>
            <span class="showSizeDiv" title="File Size">(15.50 MB)</span>
          </div>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster=""
            style="width: 100%"
            id="M833_macVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/TP81/MAC%E7%89%88%E6%9C%AC.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />

      <div class="videosDivE">
        <div class="leftDiv" style="padding-top: 3%">
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/chrome.png"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Chrome OS</a>
        </div>
        <div class="centerDiv" style="padding-top: 3%">
          <p>Download Extension For Chrome OS</p>
          <div class="bottomDownloadDiv" style="padding: 0">
            <div
              class="downloadBtnNew"
              title="Click to download"
              @click="
                () => {
                  window.open(
                    'https://chrome.google.com/webstore/detail/labelife/fahkjfnppokdemlfodklgmdklmcllidl'
                  );
                }
              "
            >
              DOWNLOAD
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
              />
            </div>
          </div>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="TP81_tattoo_chromeVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/M08F/Chorme%20OS.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/pm246sLinux.png"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Linux</a>
        </div>
        <div class="centerDiv" style="padding-top: 3%">
          <p>Download Driver For Linux System</p>
          <div class="bottomDownloadDiv">
            <div
              class="downloadBtnNew"
              title="Click to download"
              @click="
                () => {
                  window.open(
                    'https://oss.qu-in.life/Phomemo/QY_Printer_Driver_Linux.zip'
                  );
                }
              "
            >
              DOWNLOAD
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
              />
            </div>
            <span class="showSizeDiv" title="File Size">(0.34 MB)</span>
          </div>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="TP81_tattoo_linuxVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/pm246s_linux.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://pages.phomemo.com/resources/phomemoAppQrCode.png"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">APP for Smart Phone</a>
        </div>
        <div class="centerDiv" style="padding-top: 3%">
          <p>iOS 13 and above</p>
          <p>Android 7 and above</p>
          <div class="bottomDownloadDiv" style="padding: 0">
            <div
              class="downloadBtnNew"
              title="Click to download"
              @click="
                () => {
                  window.open('https://downloadapp.qu-in.life/MrIn-Phomemo/');
                }
              "
            >
              LEARN MORE
              <img :src="downloadIconMini" />
            </div>
          </div>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="TP81_tattoo_APPVideo"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/others/TP88AppVideo.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv" style="margin-top: 40px" ref="appDownloadRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/driversIcon.png"
          style="margin: 0"
        />
        <div class="textContainer">APP</div>
      </div>
      <div class="appDownloadContainer">
        <div class="everyItemArea">
          <img src="https://oss.qu-in.top/printerFiles/phomemo/others/iosPhomemoQr.png" style="max-width: 150px" />
          <h3>Phomemo APP - IOS</h3>
          <p>Easily print from your iOS device with the Phomemo App</p>
          <p>
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP81_tattoo_AppStore' });
                  window.open(
                    'https://apps.apple.com/us/app/phomemo/id1456102145'
                  );
                }
              "
              target="_blank"
              title="Click to download"
              >LEARN MORE</a
            >
          </p>
        </div>
        <div class="dividerLineDiv"></div>
        <div class="everyItemArea">
          <img src="https://oss.qu-in.top/printerFiles/phomemo/others/androidPhomemoQr.png" style="max-width: 150px" />
          <h3>Phomemo APP - Android</h3>
          <p>Easily print from your Android device with the Phomemo App</p>
          <p>
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP81_tattoo_GooglePlay' });
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.quyin.phomemo'
                  );
                }
              "
              target="_blank"
              title="Click to download"
              >LEARN MORE</a
            >
          </p>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv faqBarDiv" ref="faqRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/faqsIcon.png"
          style="margin: 0"
        />
        <div class="textContainer" title="Frequently Asked Questions">FAQ</div>
      </div>
      <div class="faq-content-area" style="margin-top: 30px">
        <div class="faq-container">
          <div class="faq-item" v-for="(item, index) in faqData" :key="index">
            <div class="faq-title" @click="clickQuestion2(item, index)">
              <span v-text="item.title"></span>
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/delIconImg.png"
                class="downArrow"
                v-show="activeQuestion2.index === index"
              />
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/addIconImg.png"
                class="downArrow"
                v-show="activeQuestion2.index !== index"
              />
            </div>
            <div class="faq-scroll-area">
              <div
                class="faq-content"
                v-show="activeQuestion2.index === index"
                v-for="child in item.details"
              >
                <div class="content-title" v-html="child.theme"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr style="color: rgba(51, 61, 71, 0.3); margin: 50px 3% 0" />
    <!--   联系方式 -->
    <div class="contactWrapper" ref="contactRef">
      <h1>Contact Us</h1>
      <div class="everyRow">
        <svg
          t="1711532586488"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="4745"
          width="36"
          height="36"
        >
          <path
            d="M926.47619 355.644952V780.190476a73.142857 73.142857 0 0 1-73.142857 73.142857H170.666667a73.142857 73.142857 0 0 1-73.142857-73.142857V355.644952l304.103619 257.828572a170.666667 170.666667 0 0 0 220.745142 0L926.47619 355.644952zM853.333333 170.666667a74.044952 74.044952 0 0 1 26.087619 4.778666 72.704 72.704 0 0 1 30.622477 22.186667 73.508571 73.508571 0 0 1 10.678857 17.67619c3.169524 7.509333 5.12 15.652571 5.607619 24.210286L926.47619 243.809524v24.380952L559.469714 581.241905a73.142857 73.142857 0 0 1-91.306666 2.901333l-3.632762-2.925714L97.52381 268.190476v-24.380952a72.899048 72.899048 0 0 1 40.155428-65.292191A72.97219 72.97219 0 0 1 170.666667 170.666667h682.666666z"
            p-id="4746"
            fill="#e53f3f"
          ></path>
        </svg>
        Email：<a
          href="mailto:support@phomemo.com"
          @click="
            () => {
              refreshRecord({ key: 'M832_email' });
            }
          "
          >support@phomemo.com</a
        >
      </div>
      <div class="everyRow">
        <svg
          t="1711532541066"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3541"
          width="36"
          height="36"
        >
          <path
            d="M398.652952 165.692952c-32.280381-46.006857-58.172952-61.318095-92.867047-54.808381-14.969905 2.80381-24.210286 7.850667-41.20381 22.528l-12.946285 11.361524-25.185524 20.894476-6.582857 5.753905c-3.705905 3.413333-6.38781 6.217143-9.825524 10.118095-64 72.46019-81.724952 185.782857-44.470857 292.327619 26.794667 76.55619 74.605714 152.624762 142.774857 228.644572 72.289524 80.62781 133.046857 131.364571 202.922666 168.374857 54.857143 29.013333 96.865524 41.74019 145.676191 43.227429 59.001905 1.828571 110.957714-11.50781 153.648762-39.15581a162.133333 162.133333 0 0 0 19.553524-15.189333l8.289523-7.558095 16.335239-15.213715 5.534476-4.924952 10.922666-9.435429c22.040381-19.651048 29.184-31.939048 30.646858-51.370666 2.194286-29.647238-11.215238-52.736-49.737143-85.699048l-26.063238-21.820952-12.117334-10.581334-11.459047-9.825524c-37.229714-30.744381-64.804571-40.69181-100.205715-35.35238-24.283429 3.632762-38.278095 12.141714-63.073523 38.107428l-10.947048 11.654095c-18.041905 19.017143-28.330667 26.258286-43.544381 29.305905-22.25981 4.461714-44.373333-7.046095-80.262095-36.205714-46.250667-37.546667-84.626286-80.676571-117.613715-131.949714-22.869333-35.766857-31.890286-62.902857-24.941714-87.600762 2.82819-9.99619 9.679238-17.042286 24.064-28.184381l14.994286-11.312762 2.413714-1.877334 22.747429-18.553904c20.114286-16.822857 28.281905-28.281905 32.572952-45.836191 8.899048-36.10819 0.487619-66.072381-32.426667-117.638095l-15.62819-24.234667-5.558857-8.533333-6.436572-9.435429z"
            p-id="3542"
            fill="#e53f3f"
          ></path>
        </svg>
        Tel：+1 855 957 5321(US ONLY)
      </div>
      <div class="everyRow">Whatsapp：+86 15338193665</div>
    </div>

    <!-- <hr style="color: rgba(51, 61, 71, 0.3); margin: 10px 3% 0" />
    <div class="alsoLikeWrapper" ref="alsoLikeRef">
      <h1>You May Also Like</h1>
      <h4>Combine your style with these products</h4>
      <div class="itemsWrapper">
        <div
          class="img-item"
          v-for="(item, index) in tp88Info.alsoLikeArr"
          :key="index"
        >
          <div class="imgInner">
            <div
              class="imgBox"
              :style="{
                paddingTop: item.isLowerImg ? '40px' : '',
                paddingLeft: item.isLowerImg ? '6px' : '',
                paddingRight: item.isLowerImg ? '6px' : '',
                background: item.isLowerImg ? '#fff' : '',
              }"
            >
              <img
                :src="item.img"
                title="Click to learn more"
                @click="
                  () => {
                    window.open(item.productUrl);
                  }
                "
              />
            </div>
            <div class="itemTitle">{{item.site}}:</div>
            <p :title="item.allTitle">
              {{ item.title }}
            </p>
            <div style="padding: 0 6px">
              <div
                class="downloadBtnNewestEx"
                title="Click to view"
                @click="
                  () => {
                    window.open(item.productUrl);
                  }
                "
              >
                View More
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="back-to-top-div">
      <a @click="backTop"><img :src="toTopIcon" /><br />Back to top</a>
    </div>
  </div>
</template>

<script>
const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
import { refreshRecord } from "@/util.js";
import { tp88Info } from "./dataConfig.js";

export default {
  name: "TP88",
  props: {},
  data() {
    return {
      tp88Info,
      faqData: tp88Info.faqData || [],
      activeQuestion2: {},
      isMobile,
      window,
      appDownIcon: require("@/assets/appDownIcon.jpg"),
      clickName: "",
      toTopIcon: require("@/assets/toTopIcon.png"),
      refreshRecord,
      downloadIconMini:
        "https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png",
    };
  },
  mounted() {
    this.listenVideo("TP81_tattoo_macVideo");
    this.listenVideo("TP81_tattoo_windowsVideo");
    this.listenVideo("TP81_tattoo_chromeVideo");
    this.listenVideo("TP81_tattoo_linuxVideo");
    this.listenVideo("TP81_tattoo_APPVideo");
  },
  methods: {
    listenVideo(videoId) {
      document.getElementById(videoId).addEventListener("play", function () {
        // console.log("视频开始播放了！");
        refreshRecord({ key: videoId });
      });
    },
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        refreshRecord({ key: "TP81_tattoo_FAQ" + (index + 1) });
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
    backTop() {
      const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
          window.requestAnimationFrame(scrollToTop);
          window.scrollTo(0, c - c / 8);
        }
      };
      scrollToTop();
      this.clickName = "";
    },

    turnToItem(refName = "") {
      const ref = this.$refs[refName];
      this.clickName = refName;
      if (ref && ref.scrollIntoView) ref.scrollIntoView();
    },
  },
};
</script>

<style lang="less" src="./newM833.less" />



// WEBPACK FOOTER //
// src/view/guides/TP88.vue